{
  "C:": {
    "type": "folder",
    "name": "C:",
    "info": {
      "size": "104000000000",
      "used": "90000000000",
      "spid": "%cdrive%"
    },
    "data": {
      "backup": {
        "type": "folder",
        "name": "backup",
        "data": {
          "config": {
            "type": "folder",
            "name": "config"
          }
        }
      },
      "FirstDesk": {},
      "Program Files": {
        "data": {
          "7-Zip": {},
          "Adobe": {},
          "AMD": {},
          "BraveSoftware": {},
          "Common Files": {},
          "Dell": {},
          "dotnet": {},
          "Git": {},
          "Goodix": {},
          "heroku": {},
          "Intel": {},
          "Internet Explorer": {},
          "mcafee": {},
          "Productivity Suite": {},
          "Cloud Drive": {},
          "Update Health Tools": {},
          "ModifiableSystemApps": {},
          "MongoDB": {},
          "MSBuild": {},
          "MySQL": {},
          "nodejs": {},
          "OpenVPN": {},
          "PCHealthCheck": {},
          "PowerShell": {},
          "PowerToys": {},
          "Realtek": {},
          "Reference Assemblies": {},
          "Riot Vanguard": {},
          "Rivet Networks": {},
          "Waves": {},
          "Security": {},
          "Mail": {},
          "Media Player": {},
          "OS Runtime": {},
          "Photo Viewer": {},
          "PowerShell": {},
          "WinRAR": {}
        }
      },
      "temp": {},
      "Users": {
        "type": "folder",
        "name": "Users",
        "data": {
          "Public": {
            "data": {
              "Public Documents": {},
              "Public Downloads": {},
              "Public Music": {},
              "Public Pictures": {},
              "Public Videos": {}
            }
          },
          "Student": {
            "type": "folder",
            "name": "Student",
            "info": {
              "spid": "%user%",
              "icon": "user"
            },
            "data": {
              ".config": {},
              "AppData": {},
              "Desktop": {
                "info": {
                  "spid": "%desktop%",
                  "icon": "desk"
                }
              },
              "Documents": {
                "info": {
                  "spid": "%documents%",
                  "icon": "docs"
                },
                "data": {
                  "2020": {
                    "data": {
                      "Covid": {},
                      "Lockdown": {},
                      "OS Release": {},
                      "Vaccination": {}
                    }
                  },
                  "Adobe": {},
                  "Attachments": {},
                  "Battle Royal": {},
                  "BioWare": {},
                  "Custom": {},
                  "Downloadable": {},
                  "Fax": {},
                  "FeedbackHub": {},
                  "Freelancing": {},
                  "My Games": {},
                  "Notes notebooks": {},
                  "OnScreen Control": {},
                  "Mail archives": {},
                  "Visual Studio": {}
                }
              },
              "Downloads": {
                "info": {
                  "spid": "%downloads%",
                  "icon": "down"
                },
                "data": {
                  "Hitman 3": {},
                  "Atomforces": {},
                  "Compressed": {},
                  "textures": {},
                  "Not A Virus": {}
                }
              },
              "Music": {
                "info": {
                  "spid": "%music%",
                  "icon": "music"
                },
                "data": {
                  "Hip Hop": {},
                  "Old School": {},
                  "60s Songs": {}
                }
              },
              "Pictures": {
                "info": {
                  "spid": "%pictures%",
                  "icon": "pics"
                },
                "data": {
                  "DCIM": {},
                  "2007": {},
                  "High School": {
                    "data": {
                      "Did you really expected that": {}
                    }
                  }
                }
              },
              "Videos": {
                "info": {
                  "spid": "%videos%",
                  "icon": "vid"
                },
                "data": {
                  "screen-recordings": {}
                }
              },
              "Projects": {
                "info": {
                  "spid": "%projects%"
                },
                "data": {
                  "atomforces": {},
                  "firstdesk-api": {},
                  "LabNotes": {},
                  "LabPortal": {},
                  "student-portal": {},
                  "evidence-capture": {},
                  "lab-tools": {},
                  "directory-lab": {},
                  "network-lab": {},
                  "helpdesk-lab": {},
                  "handwritten-digit-recognition": {},
                  "jiosaavn": {},
                  "jiosaavn-api": {},
                  "minesweeper": {},
                  "othello": {},
                  "Saavn-Downloader": {},
                  "Sanfoundary": {}
                }
              },
              "Cloud Drive": {
                "type": "folder",
                "name": "Cloud Drive",
                "info": {
                  "spid": "%clouddrive%",
                  "icon": "folder"
                },
                "data": {
                  "Atom": {
                    "data": {
                      "Codeforces": {},
                      "JavaScript": {},
                      "Projects": {}
                    }
                  },
                  "Attachments": {},
                  "october": {},
                  "Productivity": {},
                  "party": {},
                  "New Folder": {}
                }
              },
              "Contacts": {},
              "Favorites": {},
              "gif": {},
              "Programs": {},
              "Postman": {}
            }
          }
        }
      },
      "System": {}
    }
  },
  "D:": {
    "name": "D:",
    "info": {
      "spid": "%ddrive%"
    },
    "data": {
      "Adobe": {},
      "Programs": {},
      "Unity": {},
      "SystemApp": {},
      "Temp": {}
    }
  }
}
